import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import DropDownIcon from './DropDownIcon'
import DropIcon from './DropIcon'
import ShowDataBase from './options/ShowDataBase'
import DownloadDataBase from './options/DownloadDataBase'
import ShowHistory from './options/ShowHistory'
import EditDatabase from './EditDatabase/EditDatabase'
import DeleteTemplate from './options/DeleteTemplate'
import NoModels from '../NoModels'

//@ts-ignore
import i18n from 'live/services/i18n'
import UploadDatabase from './options/uploadDatabase'
var xhr = require('live/services/xhr')

//TODO: MOVE THIS VAR
export enum MAIN_TABLE_MODE {
    'VIEW' = 'VIEW',
    'EDIT' = 'EDIT',
    'HISTORY' = 'HISTORY',
    'NONE' = 'NONE'
}
interface Props {
    models: {
        name: string
        perspective: number
    }[]
    upload: React.FC
    search: string
    historyModels: any
    removeModel: React.FC
    history: any
    param: URLSearchParams
}
export interface MODE_STATE {
    mode: MAIN_TABLE_MODE
    eventType?: string | undefined
    param?: string
}
export default function MainTable({ models = [], upload, search, historyModels, history, removeModel, param }: Props) {
    const [userPerspectives, setUserPerspectives] = useState([])
    const [livePerspectives, setLivePerspectives] = useState([])
    const [state, setState] = useState<MODE_STATE>({
        mode: MAIN_TABLE_MODE.NONE,
        eventType: ''
    })

    const getPerspectiveName = perspectiveId => {
        // if (perspectiveId == undefined) return " "
        const perspective = livePerspectives.find(p => p.id === perspectiveId)
        return perspective ? perspective.name : '--'
    }

    const filterModels = models => {
        if (!models) return []

        const perspectiveArrayName = [...models].map(model => ({
            ...model,
            perspective: getPerspectiveName(model.perspective)
        }))

        return perspectiveArrayName
    }

    useEffect(() => {
        xhr.get('/rest/perspective').then(perspectives => setLivePerspectives(perspectives.data.data))
        //@ts-ignore
        setUserPerspectives(window.Live.authorization.accessedPerspectives)
        return () => {
            setUserPerspectives([])
            setLivePerspectives([])
        }
    }, [])

    useEffect(() => {
        const newsParams = new URLSearchParams(history?.location?.search)
        const mainMode = MAIN_TABLE_MODE[newsParams.get('mode')] || MAIN_TABLE_MODE.NONE
        const eventType = newsParams.get('eventType') || ''
        const param = newsParams.get('param') || ''

        setState({
            mode: mainMode,
            eventType,
            param
        })
    }, [history, search, location.search,history?.location])

    const changeMode = (mode: MAIN_TABLE_MODE, eventType: string) => {
        history.push({
            pathname: '/datasorce',
            search: `?${new URLSearchParams({
                query: search,
                mode: String(mode),
                eventType: eventType,
                param: ''
            })}`
        })
        setState({
            mode: mode,
            eventType,
            param: undefined
        })
    }
    const hideMode = () => {
        history.push({
            pathname: '/datasorce',
            search: `?${new URLSearchParams({
                query: search,
                mode: MAIN_TABLE_MODE.NONE.toString(),
                eventType: '',
                param: ''
            })}`
        })
        setState(() => ({
            mode: MAIN_TABLE_MODE.NONE,
            eventType: '',
            param: ''
        }))
    }
    useEffect(() =>{
        if(state.mode !== MAIN_TABLE_MODE.NONE  && !state.eventType){
            hideMode()
        }
    },[state])
    const setParam = (param: string) => {
        history.push({
            pathname: '/datasorce',
            search: `?${new URLSearchParams({
                query: search,
                mode: state.mode,
                eventType: state.eventType,
                param: param
            })}`
        })
        setState(curr => ({
            ...curr,
            param
        }))
    }

    const checkModel = (obj, model, key) => {
        if (obj[model] != undefined) {
            return obj[model][key]
        } else {
            return '--'
        }
    }

    if (models.length < 1) {
        return <NoModels />
    }

    return (
        <TableContainer>
            <table id="myTable">
                <thead>
                    <tr>
                        <th>Database</th>
                        <th className="td-center">{i18n('Perspective')}</th>
                        <th className="td-center">{i18n('Last Update by')}</th>
                        <th className="td-center">{i18n('Last Update')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {filterModels(models)
                        .filter(model => {
                            return (
                                model.databaseName?.toLowerCase().includes(search.toLowerCase()) ||
                                model.name?.toLowerCase().includes(search.toLowerCase())
                            )
                        })
                        .map((model, index) => (
                            <tr key={index}>
                                <td>
                                    <label>{model.databaseName || model.name}</label>
                                </td>

                                <td className="td-center">{model.perspective}</td>

                                <td className="td-center">
                                    <p>{checkModel(historyModels, model.name, 'user')}</p>
                                </td>
                                <td className="td-center">
                                    <p>{checkModel(historyModels, model.name, 'date')}</p>
                                </td>
                                <td>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end'
                                        }}
                                    >
                                        <DropIcon
                                            upload={upload}
                                            history={history}
                                            isModel={true}
                                            model={model.name}
                                        ></DropIcon>

                                        <DropDownIcon title={'spreadsheet options'}>
                                            <ShowDataBase
                                                model={state.eventType}
                                                hide={() => hideMode()}
                                                open={type => changeMode(MAIN_TABLE_MODE.VIEW, model.eventType)}
                                                show={!!state.eventType && state.mode == MAIN_TABLE_MODE.VIEW && model.eventType == state.eventType}
                                            />
                                            <EditDatabase
                                                model={state.eventType}
                                                hide={() => hideMode()}
                                                open={type => changeMode(MAIN_TABLE_MODE.EDIT, model.eventType)}
                                                show={!!state.eventType && state.mode == MAIN_TABLE_MODE.EDIT && model.eventType == state.eventType}
                                                setParam={setParam}
                                                param={state?.param}
                                            />
                                            <DeleteTemplate model={model.name} remove={removeModel} />
                                            {/*
                                            <UploadDatabase model={model.name} />
                                            <DownloadDataBase model={model.name} />
                                            <ShowHistory model={model.name} />
                                             */}
                                        </DropDownIcon>
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </TableContainer>
    )
}

const TableContainer = styled.div`
    /* height: 78%; */
    max-height: 78%;
    min-height: 78%;
background-color: var(--gray-0);
    overflow-y: scroll;

    padding: 0 10%;
    margin: 10px 0;
    font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 600;

    table {
        width: 100%;
        height: 100%;
    }
    thead {
        height: 80px;
        padding: 10px;
    }
    th {
        position: sticky;
        padding: 7px 6px;
        top: 0;
        font-size: 14px;
        color: var(--gray-700);
        font-style: normal;
        text-transform: bold;
    background-color: var(--gray-0);
        z-index: 10;
    }

    tr {
        padding: 8px 6px;
        border-bottom: 1px solid var(--gray-300);
        &:hover {
            background-color: var(--blue-200);
        }
    }
    td {
        padding: 18px 6px;
        font-size: 12px;
        line-height: 16px;
        font-family: Source Sans Pro, Open Sans Pro, Arial, Helvetica, sans-serif;
        font-style: normal;
        font-weight: normal;
        max-height: 16px;
        color: var(--gray-800);

        label {
            text-transform: uppercase;
            color: var(--gray-800);
        }

        p {
            all: unset;
            color: var(--gray-600);
        }
    }
    tbody {
        position: relative;
        overflow-y: scroll;
    }

    .td-center {
        text-align: center;
    }
`
